import {App} from "./App";

App.init()